import { render, staticRenderFns } from "./contacts-profile.vue?vue&type=template&id=72cc5b13"
import script from "./contacts-profile.vue?vue&type=script&lang=js"
export * from "./contacts-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports